import React from 'react'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { requestSharedDocuments } from 'services/DocumentService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import Loading from 'components/shared/Loading'
import SectionsDocumentsList from 'components/documents/SectionsDocumentsList'

export default function DocumentsReview (props) {
  const data = useObservable(
    requestSharedDocuments(props.sectionId, props.documentIds),
    RESPONSE_PENDING
  )

  return (
    <ResponseConsumer
      response={data}
      pendingComponent={() => <Loading />}
      content={() => (
        <div className='layout-width-constraint'>
          <h1>{data.title}</h1>
          <SectionsDocumentsList data={[data]} />
        </div>
      )}
    />
  )
}
